import { render, staticRenderFns } from "./upload-score-education.vue?vue&type=template&id=23cb7508&scoped=true&"
import script from "./upload-score-education.vue?vue&type=script&lang=js&"
export * from "./upload-score-education.vue?vue&type=script&lang=js&"
import style0 from "./upload-score-education.vue?vue&type=style&index=0&id=23cb7508&lang=stylus&scoped=true&"
import style1 from "./upload-score-education.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb7508",
  null
  
)

export default component.exports